const getTime = (num) => {
  const tempHour = String(Math.trunc(num / 60));
  const hour = tempHour + ''.length === 1 ? '0' + tempHour : tempHour;
  const min = num % 60 === 0 ? '00' : num % 60;
  return { num: num, time: hour + ':' + min };
};

const timeToArray = (str) => {
  const [hour, min] = str.split(':').map(t => parseInt(t));
  return [hour, hour * 60 + min];
};

const getInterval = (interval) => {
  let times;
  let sums;
  switch (interval) {
    case 'tenth':
      times = 6;
      sums = 10;
      break;
    case 'quarter':
      times = 4;
      sums = 15;
      break;
    case 'half':
      times = 2;
      sums = 30;
      break;
    case 'one':
      times = 1;
      sums = 60;
      break;
    case 'two':
      times = 1 / 2;
      sums = 120;
      break;
    case 'three':
      times = 1 / 3;
      sums = 180;
      break;
    case 'four':
      times = 1 / 4;
      sums = 240;
      break;
    default:
      times = 1;
      sums = 60;
      break;
  }

  return { times, sums };
};

const getTimeSlots = (startTime = '00:00', endTime = '24:00', showTimeAsString = true, interval = 'tenth', blockedTimes = [], includeStartBlockedTime = true, includeEndBlockedTime = true) => {
  const [startHour, startMinute] = timeToArray(startTime);
  const [endHour] = timeToArray(endTime);
  const { times } = getInterval(interval);

  const timeslots = Array((endHour - startHour) * times).fill(0).map((timeslot, index) => {
    return startMinute + 60 / times * index;
  });

  // if (blockTimes.length > 0) {
  //   dateTimes = blockTimes.reduce(function (acc, x) {
  //     return acc
  //       .filter(function (y) {
  //         return includeStartBlockedTime ? y <= x[0] : y < x[0];
  //       })
  //       .concat(
  //         acc.filter(function (y) {
  //           return includeEndBlockedTime ? y >= x[1] : y > x[1];
  //         })
  //       );
  //   }, dateTimes);
  // }

  if (showTimeAsString) {
    return timeslots.map(x => getTime(x)).reduce((accc, element) => {
      accc['' + element.num] = element.time;
      return accc;
    }, {});
  } else {
    return timeslots;
  }
};

module.exports = {
  getTimeSlots, getTime, timeToArray
};

// console.log(getTimeSlots([[340, 550], [920, 1240]], true, "tenth"));
